export default __webpack_public_path__ + "components/wind-icon/static/WSW@2x-ff2ff5993ccb425c4b4f3d5e25a25175.png";